<template>
  <div>
    <loader v-if="is_load " />
    <template v-else>
      <template v-if="getMerchant().use_membership">
        <div class="my-4" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
          <CardMemberList 
            v-if="display == 'card-list'"  
            @change_display="changeDisplayToUserCard"
            :disabled_register="disabled_register"
            :reject_message="reject_message"
            ></CardMemberList>
          <UserMember 
            v-if="display == 'user-card'" 
            :all_data="data_req"
            @card_list="changeDisplayToCardList"
            @reload="checkStatus"></UserMember>
        </template>
      </template>
      <template v-else>
        <div class="container mt-5 pt-5 text-center">
          <img src="../../../../assets/img/icon/404.png" width="170">
          <p class="mb-2 mx-3 mt-3 body-2-2 font-semibold">{{$t('hotel.disabled-member-desc')}}</p>
          <router-link :to="'/'+getMerchant().code+'/concierge'">
            <button type="button" class="button-primary px-4 mt-2">{{$t('general.back-to-home')}}</button>
          </router-link>
        </div>
      </template>
    </template>
    <BottomNavbar></BottomNavbar>
  </div>
</template>
<script>
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import CardMemberList from '@/pages/hotel/concierge/member/CardMemberList'
  import UserMember from '@/pages/hotel/concierge/member/UserMember'
  import {mapGetters} from "vuex";
  import {get} from '@/services/index.js'

  export default{
    components: {
      BottomNavbar,
      CardMemberList,
      UserMember
    },
    metaInfo(){
      return {
        title: 'Member',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        is_load: true,
        display: 'card-list',
        data_req: {},
        disabled_register: false,
        error: '',
        reject_message: ''
      }
    },
    mounted() {
      if(this.isNotLogin()){
        this.is_load = false
      }else{
        this.checkStatus()
      }
      console.log("GO", this.getMerchant())
    },
    methods: {
      ...mapGetters(['getMerchant','isNotLogin','getMetaTitleTemplate']),
      checkStatus(){
        this.is_load = true
        get("CONCIERGE","membership/user-member-card-detail",{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
          if(res.success){
            if(res.code == 'MEMBER_ON_REQUEST' || res.code == 'MEMBER'){
              this.data_req = res
              this.display = 'user-card'
            }else{
              if(res.code == 'MEMBER_REQUEST_CANCELLED'){
                this.reject_message = res.data.notes
              }
              this.display = 'card-list'
            }
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      },
      changeDisplayToCardList(){
        this.display = 'card-list';
        this.disabled_register = true
      },
      changeDisplayToUserCard(reload=true){
        if(reload){
          this.checkStatus()
        }else{
          this.display = 'user-card';
          this.disabled_register=false
        }
      },
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/member/Member.vue